var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.icon.tooltip),expression:"icon.tooltip"}],staticClass:"ml-0 ml-lg-2",class:_vm.icon.iconClass,attrs:{"icon":_vm.icon.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }